(function () {
  if (window.__AG_PB_AMBASSADORS_INIT__) return;
  window.__AG_PB_AMBASSADORS_INIT__ = true;

  /* Clones keep the slide class, so this returns the full strip in loop mode. */
  function getSlides(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.ag-pb-ambassadors__track > .ag-pb-ambassadors__slide'));
  }

  /* Loop controller keyed by track — the positions helpers only receive the track. */
  var loops = new WeakMap();

  function getLoop(track) {
    return loops.get(track) || null;
  }

  /* Last settled real slide per block. Kept apart from the dots, which also
     update mid-drag, so a swipe can compare where it started vs where it lands. */
  var settledPages = new WeakMap();

  function toRealIndex(track, pageIndex) {
    var loop = getLoop(track);
    return loop ? loop.realIndex(pageIndex) : pageIndex;
  }

  /* Matches the block's CSS breakpoint (desktop styles start at 741px). */
  var MOBILE_MEDIA = '(max-width: 740px)';

  function isMobileViewport() {
    return window.matchMedia(MOBILE_MEDIA).matches;
  }

  function isClone(el) {
    var cloneAttr = window.AgPbSwipe && window.AgPbSwipe.CLONE_ATTR;
    return !!(cloneAttr && el && el.closest('[' + cloneAttr + ']'));
  }

  /* Looping is mobile-only: desktop shows the whole set at once, so the clones
     would just be duplicate cards to scroll past. */
  function enableLoopFor(root, track) {
    if (getLoop(track)) return;
    if (root.dataset.agPbLoop !== 'true' || !isMobileViewport()) return;
    if (!window.AgPbSwipe || !window.AgPbSwipe.enableLoop) return;

    var loop = window.AgPbSwipe.enableLoop(track, { slideSelector: '.ag-pb-ambassadors__slide' });
    if (loop) loops.set(track, loop);
  }

  function disableLoopFor(track) {
    if (!getLoop(track)) return;

    var cloneAttr = window.AgPbSwipe && window.AgPbSwipe.CLONE_ATTR;
    if (cloneAttr) {
      track.querySelectorAll('[' + cloneAttr + ']').forEach(function (clone) {
        clone.remove();
      });
    }
    delete track.dataset.agSwipeLoop;
    loops.delete(track);
  }

  function getTrackGap(track) {
    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap);
    return isNaN(gap) ? 0 : gap;
  }

  function syncAlignInset(root) {
    var section = root.closest('.shopify-section--ag-page-blocks') || root.closest('.ag-page-blocks');
    if (!section) return;

    var left = null;
    var right = null;
    var cards = section.querySelector('.ag-pb-benefits__cards');

    if (cards) {
      var cardsRect = cards.getBoundingClientRect();
      left = cardsRect.left;
      right = cardsRect.right;
    } else {
      var shell = section.querySelector('.ag-pb-shell__inner');
      if (shell) {
        var shellRect = shell.getBoundingClientRect();
        var shellStyle = window.getComputedStyle(shell);
        var padLeft = parseFloat(shellStyle.paddingLeft) || 0;
        var padRight = parseFloat(shellStyle.paddingRight) || 0;
        left = shellRect.left + padLeft;
        right = shellRect.right - padRight;
      }
    }

    if (left == null || !isFinite(left)) return;

    /* clientWidth, not innerWidth: it excludes the classic scrollbar, matching the
       coordinate space getBoundingClientRect() reports the insets in. Feeds the
       full-bleed viewport width so the track can't drift scrollbar/2 to the left. */
    var viewportWidth = document.documentElement.clientWidth;
    root.style.setProperty('--ag-pb-ambassadors-vw', viewportWidth + 'px');
    root.style.setProperty('--ag-pb-ambassadors-align-inset', Math.max(0, Math.round(left)) + 'px');

    if (right != null && isFinite(right)) {
      var rightInset = Math.max(0, Math.round(viewportWidth - right));
      root.style.setProperty('--ag-pb-ambassadors-pad-right', rightInset + 'px');
    }
  }

  function getMaxScroll(track) {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function getScrollStep(track, slides) {
    if (!track || slides.length === 0) return 0;

    var gap = getTrackGap(track);
    var slideWidth = slides[0].getBoundingClientRect().width;
    var step = slideWidth + gap;

    return step > 0 ? step : 0;
  }

  /**
   * Scroll stops: 0 (left-align) → one-card steps → maxScroll (right-align).
   * Last stop always maxScroll so end mirrors content column right edge.
   */
  function getPageScrollPositions(track, slides) {
    var maxScroll = getMaxScroll(track);

    /*
      Looping: one stop per slide, measured off the first one. The finite model below
      pins its last stop to maxScroll so the final card sits flush right — that is a
      "there is an end" behaviour and it would fight the seamless wrap, so it is skipped.
    */
    if (getLoop(track) && slides.length) {
      var origin = slides[0].offsetLeft;
      return slides.map(function (slide) {
        return Math.round(slide.offsetLeft - origin);
      });
    }

    if (maxScroll <= 1) return [0];

    var step = getScrollStep(track, slides);
    if (step <= 0) return [0, maxScroll];

    var positions = [0];
    var next = step;
    var tailThreshold = step * 0.35;

    while (next < maxScroll - tailThreshold) {
      positions.push(Math.round(next));
      next += step;
    }

    positions.push(maxScroll);
    return positions;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateActiveDot(root, pageIndex) {
    var track = root.querySelector('.js-ag-pb-ambassadors-track');
    var loop = track ? getLoop(track) : null;
    var active = loop ? loop.realIndex(pageIndex) : pageIndex;

    var dots = root.querySelectorAll('.ag-pb-ambassadors__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === active);
      dot.setAttribute('aria-current', i === active ? 'true' : 'false');
    });
  }

  function waitForScrollEnd(track, callback) {
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      track.removeEventListener('scrollend', finish);
      callback();
    }

    if ('onscrollend' in track) {
      track.addEventListener('scrollend', finish, { once: true });
      window.setTimeout(finish, 700);
      return;
    }

    window.setTimeout(finish, 450);
  }

  function scrollToOffset(root, track, targetScroll, pageIndex, velocityX) {
    if (!track) return;

    /* Mobile: changing slides closes the open card; snapping back to the same one doesn't. */
    var targetReal = toRealIndex(track, pageIndex);
    if (isMobileViewport() && targetReal !== (settledPages.get(root) || 0)) {
      collapseOpenQuotes(root);
    }

    targetScroll = Math.max(0, Math.min(targetScroll, getMaxScroll(track)));
    track.classList.add('is-navigating');

    function finishNav() {
      track.classList.remove('is-navigating');
      settledPages.set(root, targetReal);
      updateActiveDot(root, pageIndex);
      /* Re-centre on the middle set once movement stops, never mid-gesture. */
      var loop = getLoop(track);
      if (loop) loop.normalize();
    }

    if (prefersReducedMotion()) {
      track.scrollLeft = targetScroll;
      finishNav();
      return;
    }

    /* Touch releases carry the flick speed into the settle so it coasts instead of
       running the browser's fixed smooth-scroll curve. Dots/arrows keep that curve. */
    if (typeof velocityX === 'number' && window.AgPbSwipe && window.AgPbSwipe.glide) {
      window.AgPbSwipe.glide(track, targetScroll, { velocityX: velocityX, onDone: finishNav });
      return;
    }

    track.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });

    waitForScrollEnd(track, finishNav);
  }

  function getActivePageIndex(track, slides) {
    if (!track || slides.length === 0) return 0;

    var positions = getPageScrollPositions(track, slides);
    if (positions.length <= 1) return 0;

    var scrollLeft = track.scrollLeft;
    var maxScroll = getMaxScroll(track);

    /* The right-edge shortcut only makes sense for a finite track. */
    if (!getLoop(track) && scrollLeft >= maxScroll - 2) return positions.length - 1;

    var closest = 0;
    var closestDistance = Infinity;

    positions.forEach(function (position, index) {
      var distance = Math.abs(scrollLeft - position);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function syncActiveFromScroll(root, track, slides) {
    if (!track || slides.length === 0 || track.classList.contains('is-navigating')) return;
    updateActiveDot(root, getActivePageIndex(track, slides));
  }

  function resetTrackPosition(track) {
    track.classList.add('is-navigating');
    /* Looping: park on the middle set, which renders identically to scrollLeft 0. */
    var loop = getLoop(track);
    if (loop) loop.reset();
    else track.scrollLeft = 0;
    track.classList.remove('is-navigating');
    var root = track.closest('.js-ag-pb-ambassadors');
    if (root) settledPages.set(root, 0);
  }

  function buildDots(root, track, slides) {
    var dotsWrap = root.querySelector('.js-ag-pb-ambassadors-dots');
    if (!dotsWrap) return;

    dotsWrap.innerHTML = '';

    var positions = getPageScrollPositions(track, slides);

    if (positions.length <= 1) {
      dotsWrap.hidden = true;
      dotsWrap.setAttribute('aria-hidden', 'true');
      return;
    }

    dotsWrap.hidden = false;
    dotsWrap.removeAttribute('aria-hidden');
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Ambassador slides');

    /* Looping: one dot per real slide, not one per stop across all three copies. */
    var loop = getLoop(track);
    var dotCount = loop ? loop.realCount : positions.length;

    for (var i = 0; i < dotCount; i++) {
      (function (pageIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ag-pb-ambassadors__dot' + (pageIndex === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to ambassador page ' + (pageIndex + 1));
        dot.setAttribute('aria-current', pageIndex === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          var nextSlides = getSlides(root);
          var nextPositions = getPageScrollPositions(track, nextSlides);
          var index = pageIndex;

          /* Jump to whichever copy of that slide is nearest, so the dots never send
             the track on a long scroll back through the whole set. */
          if (loop) {
            var here = getActivePageIndex(track, nextSlides);
            var offset = loop.realIndex(pageIndex) - loop.realIndex(here);
            var half = loop.realCount / 2;
            if (offset > half) offset -= loop.realCount;
            if (offset < -half) offset += loop.realCount;
            index = Math.max(0, Math.min(here + offset, nextPositions.length - 1));
          }

          var target = nextPositions[index];
          if (typeof target !== 'number') {
            target = index >= nextPositions.length - 1
              ? getMaxScroll(track)
              : nextPositions[nextPositions.length - 1];
          }
          scrollToOffset(root, track, target, Math.min(index, nextPositions.length - 1));
        });
        dotsWrap.appendChild(dot);
      })(i);
    }
  }

  /**
   * Pick settle page from drag intent.
   * Pointer right (deltaX > 0) → scroll back (prev).
   * Pointer left (deltaX < 0) → scroll forward (next).
   */
  function getDragSettlePageIndex(track, slides, startPageIndex, deltaX, velocityX) {
    var positions = getPageScrollPositions(track, slides);
    if (positions.length <= 1) return 0;

    var last = positions.length - 1;
    var startIndex = Math.max(0, Math.min(startPageIndex, last));
    var step = getScrollStep(track, slides) || 1;
    var distanceThreshold = step * 0.18;
    var velocityThreshold = 0.45; /* px/ms */
    var wentForward = deltaX < -distanceThreshold || velocityX < -velocityThreshold;
    var wentBackward = deltaX > distanceThreshold || velocityX > velocityThreshold;

    if (wentForward) return Math.min(startIndex + 1, last);
    if (wentBackward) return Math.max(startIndex - 1, 0);

    return getActivePageIndex(track, slides);
  }

  function settleToPage(root, track, pageIndex, velocityX) {
    var slides = getSlides(root);
    var positions = getPageScrollPositions(track, slides);
    if (positions.length === 0) return;

    var index = Math.max(0, Math.min(pageIndex, positions.length - 1));
    scrollToOffset(root, track, positions[index], index, velocityX);
  }

  function setMoreLabel(btn, expanded) {
    var more = btn.getAttribute('data-label-more') || 'Read more';
    var less = btn.getAttribute('data-label-less') || 'Read less';
    btn.textContent = expanded ? less : more;
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function getClampLineCount() {
    return isMobileViewport() ? 4 : 3;
  }

  function getQuoteLineHeight(quote) {
    var style = window.getComputedStyle(quote);
    var lineHeight = parseFloat(style.lineHeight);
    if (!lineHeight || isNaN(lineHeight)) {
      var fontSize = parseFloat(style.fontSize) || 16;
      lineHeight = fontSize * 1.5;
    }
    return lineHeight;
  }

  function syncReadMore(root) {
    root.querySelectorAll('.js-ag-pb-ambassadors-quote').forEach(function (quote) {
      if (isClone(quote)) return;
      if (quote.classList.contains('is-animating')) return;

      var wrap = quote.parentElement;
      var btn = wrap ? wrap.querySelector('.js-ag-pb-ambassadors-more') : null;
      if (!btn) return;

      if (quote.classList.contains('is-expanded')) {
        quote.classList.remove('is-clamped');
        btn.hidden = false;
        setMoreLabel(btn, true);
        return;
      }

      /* Measure unclamped height vs line-clamp cap. Do not use clientHeight
         after -webkit-line-clamp — WebKit often reports the full height, which
         made every card look expanded. */
      quote.style.height = '';
      quote.classList.remove('is-clamped');
      var fullHeight = quote.scrollHeight;
      var clampedHeight = Math.round(getQuoteLineHeight(quote) * getClampLineCount());
      var overflows = fullHeight > clampedHeight + 2;

      quote.dataset.clampedH = String(clampedHeight);
      if (overflows) {
        quote.classList.add('is-clamped');
        btn.hidden = false;
      } else {
        quote.classList.remove('is-clamped');
        btn.hidden = true;
      }
      setMoreLabel(btn, false);
    });
  }

  /* Closed cards share one height. Expanded card can grow past it; siblings stay put. */
  function syncClosedHeights(root) {
    if (root.querySelector('.js-ag-pb-ambassadors-quote.is-animating')) return;

    root.style.removeProperty('--ag-pb-ambassadors-closed-h');

    var max = 0;
    root.querySelectorAll('.ag-pb-ambassadors-card').forEach(function (card) {
      if (isClone(card)) return;

      var quote = card.querySelector('.js-ag-pb-ambassadors-quote');
      var expanded = quote && quote.classList.contains('is-expanded');
      var h;

      if (expanded) {
        h = parseFloat(card.dataset.agPbClosedH) || 0;
      } else {
        h = card.getBoundingClientRect().height;
        card.dataset.agPbClosedH = String(Math.round(h));
      }

      if (h > max) max = h;
    });

    if (max > 0) {
      root.style.setProperty('--ag-pb-ambassadors-closed-h', Math.round(max) + 'px');
    }
  }

  function syncQuotes(root) {
    syncReadMore(root);
    syncClosedHeights(root);
  }

  function onQuoteAnimEnd(quote, callback) {
    var done = false;

    function end(event) {
      if (done) return;
      if (event && event.target !== quote) return;
      if (event && event.propertyName && event.propertyName !== 'height') return;
      done = true;
      window.clearTimeout(timer);
      quote.removeEventListener('transitionend', end);
      quote.classList.remove('is-animating');
      quote.style.height = '';
      if (callback) callback();
    }

    var timer = window.setTimeout(end, 500);
    quote.addEventListener('transitionend', end);
  }

  function cacheClosedCardHeight(quote) {
    var card = quote.closest('.ag-pb-ambassadors-card');
    if (card && !card.dataset.agPbClosedH) {
      card.dataset.agPbClosedH = String(Math.round(card.getBoundingClientRect().height));
    }
  }

  function expandQuote(quote, btn) {
    cacheClosedCardHeight(quote);
    var start = quote.clientHeight;
    quote.dataset.clampedH = String(start);
    setMoreLabel(btn, true);
    quote.classList.add('is-expanded');
    quote.classList.remove('is-clamped');

    if (prefersReducedMotion()) {
      quote.style.height = '';
      return;
    }

    quote.style.height = start + 'px';
    quote.classList.add('is-animating');
    quote.offsetHeight;
    quote.style.height = quote.scrollHeight + 'px';
    onQuoteAnimEnd(quote);
  }

  function collapseQuoteInstant(quote, btn) {
    quote.classList.remove('is-animating', 'is-expanded');
    quote.classList.add('is-clamped');
    quote.style.height = '';
    if (btn) setMoreLabel(btn, false);
  }

  function collapseOpenQuotes(root) {
    var closed = false;

    root.querySelectorAll('.js-ag-pb-ambassadors-quote.is-expanded').forEach(function (quote) {
      var wrap = quote.parentElement;
      var btn = wrap ? wrap.querySelector('.js-ag-pb-ambassadors-more') : null;
      collapseQuoteInstant(quote, btn);
      closed = true;
    });

    if (closed) syncClosedHeights(root);
  }

  function collapseQuote(quote, btn, root) {
    var start = quote.scrollHeight;
    var end = parseFloat(quote.dataset.clampedH);

    if (!(end > 0)) {
      quote.classList.add('is-clamped');
      quote.classList.remove('is-expanded');
      end = quote.clientHeight;
      quote.classList.remove('is-clamped');
    }

    setMoreLabel(btn, false);

    if (prefersReducedMotion()) {
      quote.classList.remove('is-expanded');
      quote.classList.add('is-clamped');
      quote.style.height = '';
      syncQuotes(root);
      return;
    }

    quote.style.height = start + 'px';
    quote.classList.add('is-animating');
    quote.classList.remove('is-expanded');
    quote.offsetHeight;
    quote.style.height = end + 'px';
    onQuoteAnimEnd(quote, function () {
      quote.classList.add('is-clamped');
      syncQuotes(root);
    });
  }

  function toggleQuote(btn, root) {
    if (!btn || !root.contains(btn)) return;

    var wrap = btn.parentElement;
    var quote = wrap ? wrap.querySelector('.js-ag-pb-ambassadors-quote') : null;
    if (!quote) return;

    /* Interrupt in-flight height anim so a second tap is never a no-op. */
    if (quote.classList.contains('is-animating')) {
      quote.classList.remove('is-animating');
      quote.style.height = '';
    }

    if (quote.classList.contains('is-expanded')) collapseQuote(quote, btn, root);
    else expandQuote(quote, btn);
  }

  function bindReadMore(root) {
    if (root.dataset.agPbAmbassadorsMoreReady === 'true') return;
    root.dataset.agPbAmbassadorsMoreReady = 'true';

    function stopIfMore(event) {
      if (event.target.closest('.js-ag-pb-ambassadors-more')) {
        event.stopPropagation();
      }
    }

    /* Capture: stop before the track swipe hears the gesture. */
    root.addEventListener('pointerdown', stopIfMore, true);
    root.addEventListener('touchstart', stopIfMore, { capture: true, passive: true });

    /*
      iOS/Android: a tap that moves a few px still fires touchend but often
      never a click (carousel touchmove preventDefault). Toggle on touchend.
    */
    root.addEventListener(
      'touchend',
      function (event) {
        var btn = event.target.closest('.js-ag-pb-ambassadors-more');
        if (!btn || !root.contains(btn)) return;
        if (event.changedTouches && event.changedTouches.length !== 1) return;

        event.preventDefault();
        event.stopPropagation();
        root.dataset.agPbAmbassadorsTouchToggle = 'true';
        toggleQuote(btn, root);
        window.setTimeout(function () {
          delete root.dataset.agPbAmbassadorsTouchToggle;
        }, 400);
      },
      { capture: true, passive: false }
    );

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('.js-ag-pb-ambassadors-more');
      if (!btn || !root.contains(btn)) return;

      event.preventDefault();
      event.stopPropagation();
      if (root.dataset.agPbAmbassadorsTouchToggle === 'true') return;

      toggleQuote(btn, root);
    });
  }

  function initDragScroll(track, root) {
    if (track.dataset.agPbAmbassadorsDragReady === 'true') return;
    track.dataset.agPbAmbassadorsDragReady = 'true';

    var isDragging = false;
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var startPageIndex = 0;
    var startTime = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocityX = 0;
    var dragged = false;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (track.classList.contains('is-navigating')) return;
      if (event.target.closest('button, a, input, textarea, select')) return;

      isDragging = true;
      dragged = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      lastX = event.clientX;
      startScrollLeft = track.scrollLeft;
      startPageIndex = getActivePageIndex(track, getSlides(root));
      startTime = Date.now();
      lastTime = startTime;
      velocityX = 0;
      track.classList.add('is-dragging');

      if (track.setPointerCapture) {
        track.setPointerCapture(event.pointerId);
      }
    });

    track.addEventListener('pointermove', function (event) {
      if (!isDragging || event.pointerId !== pointerId) return;

      var now = Date.now();
      var deltaX = event.clientX - startX;
      var frameDt = now - lastTime;

      if (frameDt > 0) {
        velocityX = (event.clientX - lastX) / frameDt;
      }

      lastX = event.clientX;
      lastTime = now;

      if (Math.abs(deltaX) > 4) dragged = true;

      track.scrollLeft = Math.max(0, Math.min(startScrollLeft - deltaX, getMaxScroll(track)));
      event.preventDefault();
    });

    function endDrag(event) {
      if (!isDragging) return;
      if (event && pointerId != null && event.pointerId !== pointerId) return;

      var deltaX = (event && typeof event.clientX === 'number' ? event.clientX : lastX) - startX;
      var elapsed = Math.max(Date.now() - startTime, 1);

      /* Blend last frame velocity with overall swipe velocity */
      var overallVelocity = deltaX / elapsed;
      var settleVelocity = Math.abs(velocityX) > Math.abs(overallVelocity) ? velocityX : overallVelocity;

      isDragging = false;
      pointerId = null;

      if (track.releasePointerCapture && event && track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }

      if (!dragged) {
        track.classList.remove('is-dragging');
        return;
      }

      track.dataset.agPbAmbassadorsSuppressClick = 'true';
      window.setTimeout(function () {
        delete track.dataset.agPbAmbassadorsSuppressClick;
      }, 0);

      /* Keep snap/interaction lock until settle scroll finishes */
      track.classList.add('is-navigating');
      track.classList.remove('is-dragging');

      var settleIndex = getDragSettlePageIndex(
        track,
        getSlides(root),
        startPageIndex,
        deltaX,
        settleVelocity
      );

      settleToPage(root, track, settleIndex);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', function (event) {
      if (isDragging) endDrag(event);
    });

    track.addEventListener('click', function (event) {
      if (track.dataset.agPbAmbassadorsSuppressClick === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    /* Touch native scroll: settle to nearest page when momentum ends */
    track.addEventListener('scrollend', function () {
      /* Continuous scroll rests wherever it paused — don't snap it to a stop. */
      if (track.__agPbAutoScroll) return;
      if (track.classList.contains('is-dragging') || track.classList.contains('is-navigating')) return;
      if (track.dataset.agPbAmbassadorsDragReady !== 'true') return;

      var slides = getSlides(root);
      var positions = getPageScrollPositions(track, slides);
      if (positions.length <= 1) return;

      var index = getActivePageIndex(track, slides);
      var target = positions[index];
      if (Math.abs(track.scrollLeft - target) < 2) {
        settledPages.set(root, toRealIndex(track, index));
        updateActiveDot(root, index);
        return;
      }

      settleToPage(root, track, index);
    });
  }

  function refreshLayout(root, track) {
    syncAlignInset(root);
    var slides = getSlides(root);
    buildDots(root, track, slides);
    syncActiveFromScroll(root, track, slides);
    syncQuotes(root);
  }

  function initBlock(root) {
    if (root.dataset.agPbAmbassadorsReady === 'true') return;

    var track = root.querySelector('.js-ag-pb-ambassadors-track');
    var slides = getSlides(root);

    if (!track || slides.length === 0) return;

    root.dataset.agPbAmbassadorsReady = 'true';

    bindReadMore(root);
    /* Measure overflow before clones copy the collapsed cards. */
    syncQuotes(root);

    /* Clone the set before anything measures, so stops and dots see the real strip. */
    enableLoopFor(root, track);

    syncAlignInset(root);
    resetTrackPosition(track);
    slides = getSlides(root);
    buildDots(root, track, slides);
    initDragScroll(track, root);
    updateActiveDot(root, 0);

    if (root.dataset.agPbAutoscroll === 'true' && window.AgPbSwipe && window.AgPbSwipe.autoScroll) {
      window.AgPbSwipe.autoScroll(track, { speed: parseFloat(root.dataset.agPbAutoscrollSpeed) });
    }

    /* Touch horizontal is JS-driven (CSS drops native h-scroll on coarse pointers).
       Settle on drag intent via the same distance/velocity rule the mouse drag uses —
       nearest-slide alone would force a >50% swipe to advance. */
    if (window.AgPbSwipe) {
      var swipeStartPage = 0;
      window.AgPbSwipe.bind(track, {
        onStart: function () {
          swipeStartPage = getActivePageIndex(track, getSlides(root));
        },
        onSettle: function (drag) {
          settleToPage(
            root,
            track,
            getDragSettlePageIndex(track, getSlides(root), swipeStartPage, drag.deltaX, drag.velocityX),
            drag.velocityX
          );
        }
      });
    }

    requestAnimationFrame(function () {
      syncAlignInset(root);
      syncQuotes(root);
      requestAnimationFrame(function () {
        resetTrackPosition(track);
        buildDots(root, track, getSlides(root));
        updateActiveDot(root, 0);
        syncQuotes(root);
      });
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncQuotes(root);
      });
    }

    var scrollRaf = false;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = true;
      requestAnimationFrame(function () {
        syncActiveFromScroll(root, track, getSlides(root));
        scrollRaf = false;
      });
    });

    /* Block can init while its section is display:none (e.g. deferred quiz results).
       ResizeObserver catches the 0 -> real size jump once it becomes visible, so
       dots/snap points get built from real measurements instead of staying stuck at 0. */
    if ('ResizeObserver' in window) {
      var lastWidth = track.clientWidth;
      var ro = new ResizeObserver(function () {
        if (track.clientWidth === lastWidth) return;
        lastWidth = track.clientWidth;
        refreshLayout(root, track);
      });
      ro.observe(track);
    }

    /* Crossing the breakpoint adds or drops the clones without re-binding the
       drag/scroll handlers, which are already wired to this track. */
    if (root.dataset.agPbLoop === 'true') {
      var mq = window.matchMedia(MOBILE_MEDIA);
      var onBreakpointChange = function () {
        if (isMobileViewport()) {
          enableLoopFor(root, track);
        } else {
          disableLoopFor(track);
        }
        resetTrackPosition(track);
        refreshLayout(root, track);
        updateActiveDot(root, 0);
      };
      if (mq.addEventListener) mq.addEventListener('change', onBreakpointChange);
      else if (mq.addListener) mq.addListener(onBreakpointChange);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        refreshLayout(root, track);
      }, 200);
    });
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-ambassadors').forEach(initBlock);
  }

  function resetAll() {
    document.querySelectorAll('.js-ag-pb-ambassadors').forEach(function (root) {
      delete root.dataset.agPbAmbassadorsReady;
      delete root.dataset.agPbAmbassadorsMoreReady;
      var track = root.querySelector('.js-ag-pb-ambassadors-track');
      if (track) delete track.dataset.agPbAmbassadorsDragReady;
    });
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', resetAll);
  document.addEventListener('shopify:block:select', resetAll);
})();
